/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { VersionId } from "../../commons/types/VersionId";
import { CommitId } from "../../commons/types/CommitId";
import { SortField } from "../../commons/types/SortField";
import { SortDirection } from "../../commons/types/SortDirection";
import { Filter } from "../../commons/types/Filter";
import { FilterField } from "../../commons/types/FilterField";
import { SearchValue } from "../../commons/types/SearchValue";
import { SearchField } from "../../commons/types/SearchField";
import { RecordId } from "../../commons/types/RecordId";
export const ExportOptions = core.serialization.object({
    versionId: VersionId.optional(),
    commitId: CommitId.optional(),
    sortField: SortField.optional(),
    sortDirection: SortDirection.optional(),
    filter: Filter.optional(),
    filterField: FilterField.optional(),
    searchValue: SearchValue.optional(),
    searchField: SearchField.optional(),
    q: core.serialization.string().optional(),
    ids: core.serialization.list(RecordId).optional(),
});
